/*!
 * @Author: luoob
 * @Date: 2021-11-08 11:14:32
 * @Last Modified by: luoob
 * @Last Modified time: 2021-11-08 11:14:35
 * @Introduction: 日志模块路由
 */

/* Layout */
import Layout from '@/layout/index.vue'

const SearchLogs = () => import('@/views/logs/index.vue')

export default {
    path: '/logs',
    component: Layout,
    redirect: '/logs/list',
    children: [
        {
            path: 'list',
            component: SearchLogs,
            name: 'SearchLogs',
            meta: {
                title: '搜索日志',
                icon: 'icon-search-logs'
            }
        }
    ]
}
